module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 13-4e9e14948f62c8578f9a2e0873aff8b4.jpg";